module.exports = __webpack_public_path__ + "img/Light_Transforms.a4cbc68d.png";